import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgPipesModule } from 'ngx-pipes';
import { InputDirective } from './directives/input.directive';
import { SelectInputDirective } from './directives/select-input.directive';
import { LanguageRestrictDirective } from './directives/language-restrict.directive';

@NgModule({
  imports: [
    CommonModule],
  exports: [
    NgPipesModule,
    InputDirective,
    SelectInputDirective,
    LanguageRestrictDirective
  ],
  declarations: [
    InputDirective,
    SelectInputDirective,
    LanguageRestrictDirective
  ]
})
export class UtilsModule {}
